import { render, staticRenderFns } from "./MonthlyBusinessReport.vue?vue&type=template&id=a3a20856&"
import script from "./MonthlyBusinessReport.vue?vue&type=script&lang=ts&"
export * from "./MonthlyBusinessReport.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyBusinessReport.vue?vue&type=style&index=0&id=a3a20856&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports